import * as React from 'react';
import styled from 'styled-components';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { BlogSticky } from '@doltech/ui/lib/figma/Blog/BlogSticky';
import { useAppScrollRef } from '@doltech/core/lib/appScroll/withAppScroll';

const Main = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  justify-content: center;
  width: 100%;
`;

const Container = styled.article`
  ${fromScreen(768)} {
    padding: 0 24px;
  }
`;

const ReadingDetailInfo = styled.aside`
  display: none;

  ${fromScreen(1240)} {
    display: block;
  }
`;

interface StudentDoTestGrammarLandingTemplateProps {
  header?: React.ReactNode;
  blogPreview?: React.ReactNode;
  detailInfo?: React.ReactNode;
}

export const StudentDoTestGrammarLandingTemplate = (props: StudentDoTestGrammarLandingTemplateProps) => {
  const { header, blogPreview, detailInfo } = props;
  const { appScrollRef } = useAppScrollRef();

  return (
    <Container>
      {header}
      <Main>
        {blogPreview}
        <BlogSticky
          key="table-of-content"
          stickyId="blog-table-of-content"
          scrollContainerElm={appScrollRef.current}
          stickOnElm="#table-of-content-stick"
          stickyMode="ALWAYS_SHOW"
          hideWhenIntersectWithElms={['.recommend-blog-list', '.section-free-test-promotion', '#shared-footer']}
          offsetY={100}
          stickOnElmPosition={{
            align: 'right',
            gapInPx: 32,
          }}
        >
          <ReadingDetailInfo>{detailInfo}</ReadingDetailInfo>
        </BlogSticky>
      </Main>
    </Container>
  );
};
